// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"818":"2c3abd63","855":"e71f01f7"}[chunkId] + ".chunk.js";
};